import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { createFormErrorHandler } from '@/utils/form-error-handler';
import AuthLayout from '../components/auth/authLayout';
import PrimaryButton from '@/components/shared/primaryButton';
import Input from '@/components/shared/input';
import * as yup from 'yup';
import { AuthMutations } from './services/mutation';
import { showError, showSuccess } from '@/libs/react.toastify';
import { useAuth } from '@/zustand/auth-store';
import tw from 'twin.macro';

const Login = () => {
  const navigate = useNavigate();
  const recaptchaRef = useRef(null);
  const { clearAuth } = useAuth();

  const schemaLogin = yup.object({
    email: yup
      .string()
      .trim()
      .required('Email is required')
      .email('Please enter a valid email address'),
  });

  useEffect(() => {
    clearAuth();
  }, [clearAuth]);

  const {
    handleSubmit,
    register,
    formState: { isSubmitting, errors, isValid },
    setError,
  } = useForm({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(schemaLogin),
    mode: 'onChange',
  });

  const { mutate: loginUser, isPending } = AuthMutations.useLoginUser({
    onSuccess: _data => {
      showSuccess('Login successful! Please check your OTP.');
      navigate('/otp-page');
    },
    onError: error => {
      if (error?.response?.status === 400) {
        const message = error?.response?.data?.email[0];
        showError(message);
      } else {
        const handleError = createFormErrorHandler(setError);
        handleError(error);
      }
    },
  });

  const handleLogin = async data => {
    const normalizedEmail = data.email.trim().toLowerCase();
    localStorage.setItem('email', normalizedEmail);
    loginUser({ email: normalizedEmail });
  };

  const isLoading = isSubmitting || isPending;

  return (
    <div>
      <AuthLayout
        customContainerStyle={tw`lg:w-[70%] w-[90%] space-y-6 lg:py-4 max-sm:w-[100%]`}
        authSection={
          <>
            <Input
              register={register}
              name="email"
              type="email"
              label="Email"
              placeholder="Enter your email"
              errorMessage={errors.email?.message}
            />
            <PrimaryButton
              isSubmitting={isLoading}
              disable={isLoading || !isValid}
              text={'continue'}
              tw="w-full py-[12px] px-[16px] rounded-[6px] max-sm:(p-[10px])  text-[.9375rem] max-sm:!mt-4 font-[600] font-['Inter']"
            />
          </>
        }
        isLogIn
        title={'login'}
        handelSubmit={handleSubmit(handleLogin)}
      />
    </div>
  );
};

export default Login;
